import { render, staticRenderFns } from "./TrainingDialog.vue?vue&type=template&id=105f4130&scoped=true&"
import script from "./TrainingDialog.vue?vue&type=script&lang=js&"
export * from "./TrainingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f4130",
  null
  
)

export default component.exports